{
    "Omclient": "Omnichannel-klant:",
    "OmclientAgentValidation": "Een Omnichannel-client vereist een eindpunt ACD-agent",
    "DeviceHint": "Selecteer het eindpunt van de supervisor om de ingebouwde browsergebaseerde oproepbesturing toe te staan",
    "OmnichannelAgent": "Omnichannel-agent:",
    "NoneSelected": "[Geen geselecteerd]",
    "NoAssociatedDevice": "[Geen bijbehorend apparaat]",
    "NoAssociatedAgent": "[Geen geassocieerde ACD-agent]",
    "ExtensionEndpoint_PermissionsNote": "Serviceniveau-instellingen",
    "ExtensionEndpoint_CmEnvironment": "CME-details",
    "ExtensionEndpoint_TelServer": "Telefonieserver:",
    "ExtensionEndpoint_Partition": "partitie:",
    "ExtensionEndpoint_Device": "Apparaat:",
    "ExtensionEndpoint_AndOrAgent": "of hier slepen en neerzetten.",
    "NAME": "ExtensionEndpoint",
    "ExtensionEndpoint_Validation_Professional_Device": "Een professionele gebruiker moet een apparaateindpunt hebben ingesteld",
    "ExtensionEndpoint_Validation_Professional_Device_MST": "Een CXA niet-gebruikte gebruiker moet een apparaateindpunt hebben ingesteld",
    "ExtensionEndpoint_Validation_CallCentreAgent_Agent": "Een Call Centre Agent moet een agent-eindpunt hebben ingesteld",
    "ExtensionEndpoint_Validation_CallCentreAgent_Agent_MST": "Een CXA Premium-gebruiker moet een agent-eindpunt hebben ingesteld",
    "ExtensionEndpoint_Validation_Professional_Device_MSTB": "Een realtimegebruiker moet beschikken over een apparaat-eindpunt dat is ingesteld.",
    "ExtensionEndpoint_Validation_CallCentreAgent_Agent_MSTB": "Een agent moet beschikken over een agent-eindpunt."
}